var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-dialog"},[_c('el-dialog',{staticClass:"el-dialog-contain prop",attrs:{"title":_vm.title,"visible":_vm.visible,"width":_vm.width,"before-close":_vm.dialogClose}},[_vm._t("default"),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }